// extracted by mini-css-extract-plugin
module.exports = {"base":"Item_base__3JfUc"};